var map = {
	"./Dailogo.png": "./src/assets/images/Dailogo.png",
	"./Symbol.png": "./src/assets/images/Symbol.png",
	"./YouSamaritan White Paper v2.pdf": "./src/assets/images/YouSamaritan White Paper v2.pdf",
	"./about.png": "./src/assets/images/about.png",
	"./bbb.png": "./src/assets/images/bbb.png",
	"./bg-banner.png": "./src/assets/images/bg-banner.png",
	"./bi_facebook.png": "./src/assets/images/bi_facebook.png",
	"./brand1.png": "./src/assets/images/brand1.png",
	"./brand2.png": "./src/assets/images/brand2.png",
	"./brand3.png": "./src/assets/images/brand3.png",
	"./brand4.png": "./src/assets/images/brand4.png",
	"./brand5.png": "./src/assets/images/brand5.png",
	"./bxs_up-arrow.png": "./src/assets/images/bxs_up-arrow.png",
	"./c1.png": "./src/assets/images/c1.png",
	"./c2.png": "./src/assets/images/c2.png",
	"./c3.png": "./src/assets/images/c3.png",
	"./c5.png": "./src/assets/images/c5.png",
	"./card_bg_t.png": "./src/assets/images/card_bg_t.png",
	"./circle.png": "./src/assets/images/circle.png",
	"./circle_b.png": "./src/assets/images/circle_b.png",
	"./desktop_views.png": "./src/assets/images/desktop_views.png",
	"./email.png": "./src/assets/images/email.png",
	"./faq.png": "./src/assets/images/faq.png",
	"./footer_logo.png": "./src/assets/images/footer_logo.png",
	"./free-reddit-logo-icon-2436-thumb 1.png": "./src/assets/images/free-reddit-logo-icon-2436-thumb 1.png",
	"./global-business.png": "./src/assets/images/global-business.png",
	"./i.fas.png": "./src/assets/images/i.fas.png",
	"./left_image.png": "./src/assets/images/left_image.png",
	"./left_line.png": "./src/assets/images/left_line.png",
	"./lines_b.png": "./src/assets/images/lines_b.png",
	"./logo.png": "./src/assets/images/logo.png",
	"./mash_right.png": "./src/assets/images/mash_right.png",
	"./mdi_twitter.png": "./src/assets/images/mdi_twitter.png",
	"./mesh-testimonials-blockchain.png": "./src/assets/images/mesh-testimonials-blockchain.png",
	"./mingcute_youtube-fill.png": "./src/assets/images/mingcute_youtube-fill.png",
	"./mission.png": "./src/assets/images/mission.png",
	"./pajamas_twitter.png": "./src/assets/images/pajamas_twitter.png",
	"./profile.jpg": "./src/assets/images/profile.jpg",
	"./right_line.png": "./src/assets/images/right_line.png",
	"./road.png": "./src/assets/images/road.png",
	"./road_map_mobile.png": "./src/assets/images/road_map_mobile.png",
	"./team_bg.png": "./src/assets/images/team_bg.png",
	"./token.png": "./src/assets/images/token.png",
	"./tokens.png": "./src/assets/images/tokens.png",
	"./tokens_b.png": "./src/assets/images/tokens_b.png",
	"./twitter.png": "./src/assets/images/twitter.png",
	"./uil_instagram-alt.png": "./src/assets/images/uil_instagram-alt.png",
	"./user.png": "./src/assets/images/user.png",
	"./video1.mp4": "./src/assets/images/video1.mp4",
	"./video2.mp4": "./src/assets/images/video2.mp4",
	"./video3.mp4": "./src/assets/images/video3.mp4",
	"./vision.png": "./src/assets/images/vision.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";